module.exports = __webpack_public_path__ + "img/ethereum.0168af96.svg";